import React from 'react'
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    makeStyles,
    Theme,
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { Link } from 'react-router-dom'

import { seasonCampaignCreatePath } from '../../Campaigns/utils/seasonCampaignUtils'

const useStyles = makeStyles((theme: Theme) => ({
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderStyle: 'dashed',
        backgroundColor: theme.palette.grey[50],
    },
    cardContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(2),
        textAlign: 'center',
        '&:last-child': {
            paddingBottom: theme.spacing(2),
        },
    },
    iconWrap: {
        width: 40,
        height: 40,
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main + '14',
        color: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing(1),
    },
    title: {
        fontWeight: 600,
        fontSize: '0.875rem',
        marginBottom: theme.spacing(0.5),
    },
    subtitle: {
        fontSize: '0.75rem',
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1.5),
    },
}))

interface NewCampaignCardProps {
    seasonId?: number | null
}

export const NewCampaignCard: React.FC<NewCampaignCardProps> = ({
    seasonId,
}) => {
    const classes = useStyles()

    return (
        <Card className={classes.card} variant="outlined">
            <CardContent className={classes.cardContent}>
                <Box className={classes.iconWrap}>
                    <AddIcon fontSize="small" />
                </Box>
                <Typography className={classes.title}>New campaign</Typography>
                <Typography className={classes.subtitle}>
                    Create a custom sequence for this season
                </Typography>
                <Button
                    component={Link}
                    to={seasonCampaignCreatePath(seasonId ?? undefined)}
                    variant="outlined"
                    color="primary"
                    size="small"
                    startIcon={<AddIcon fontSize="small" />}
                >
                    Create
                </Button>
            </CardContent>
        </Card>
    )
}
